import { Spinner } from '@aicon-dev/caas-ui';
import { theme } from '@aicon-dev/caas-ui/dist/theme.css';

import { useThemeContext } from '~/modules/common/context/ThemeProvider';

import { splash, splashCenter, splashIcon, splashSpinner } from './styles.css';

/**
 * 스플래쉬 화면을 구현할 때 사용하며, 보통 전역적인 로딩 처리에 사용합니다.
 */
export const Splash = () => {
  const { appLogo } = useThemeContext();
  return (
    <div className={splash}>
      <div className={splashCenter}>
        <img className={splashIcon} src={appLogo?.url ?? '/images/logo.svg'} />
        <div className={splashSpinner}>
          <Spinner
            style={{
              color: theme.color.primary[500],
              fontSize: '1.25rem',
            }}
          />
        </div>
      </div>
    </div>
  );
};
